import { createContext, useState} from 'react';

export const SubmittedFlag = createContext({
    isSubmitted: false,
    changeSubmitted: (isSubmitted: boolean) => {}
});

export  const SubmittedFlagProvider = ({ children }: any) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const changeSubmitted= (isSubmitted: boolean) => setIsSubmitted(isSubmitted);

    return (
        <SubmittedFlag.Provider
            value={{
                isSubmitted,
                changeSubmitted
            }}
        >
            { children }
        </SubmittedFlag.Provider>
    )
}